<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc1"><a href="#/Chapter1#C1">1. Everyone Loves a Good Ghost Story</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. The Lafayette Vampire</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Louisville’s Bootlegger Ghosts</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. La Llorona and Other Legendary Spirits</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Old Louisville Inn Ghost and Other Louisville Hauntings</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Neighborhood Ghost and Other Lafayette Hauntings</span></p>
<p class="toc1"><span href="#/AppendixA" title="Link target outside of Sample">Appendix A: The Vampyre</span></p>
<p class="toc"><span href="#/AppendixB" title="Link target outside of Sample">Appendix B: Roumenian Superstitions</span></p>
<p class="toc"><span href="#/AppendixC" title="Link target outside of Sample">Appendix C: Professor Van Helsing Gives a Team Pep Talk, Explains the Vampire’s Abilities, the Rules It Follows and Gives Instructions on How to Kill It</span></p>
<p class="toc"><span href="#/AppendixD" title="Link target outside of Sample">Appendix D: Scientific View of Ghosts</span></p>
<p class="toc"><span href="#/AppendixE" title="Link target outside of Sample">Appendix E: Preventing the Loss of a Soul</span></p>
<p class="toc"><span href="#/Sources" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?49a7a081